// import React, { useState, useEffect } from "react";
// import styles from './.FilterBoxComponents.module.css';
// import { capitalize } from "functions/fields";
// // redeploy
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const IndustryFilter = ({ industries, setIndustries }) => {
//     const [industryInput, setIndustryInput] = useState('');
//     const [filteredSuggestions, setFilteredSuggestions] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [industrySuggestions, setIndustrySuggestions] = useState([]); // <-- Load once

//     // Fetch suggestions once on mount
// 	useEffect(() => {
// 		const fetchSuggestions = async () => {
// 			try {
// 				const res = await fetch(`${API_BASE_URL}/get_industry_suggestions`, {
// 					method: 'POST',
// 					headers: { 'Content-Type': 'application/json' },
// 				});  
	
// 				const data = await res.json(); // 👈 You missed this
// 				const list = data.results.map(r => r.industry).filter(Boolean);
// 				setIndustrySuggestions([...new Set(list.map(s => s.trim().toLowerCase()))]); // clean + dedup
// 			} catch (err) {
// 				console.error("Failed to fetch industry suggestions:", err);
// 			}
// 		};
// 		fetchSuggestions();
// 	}, []);

//     const handleIndustryInputChange = (event) => {
//         const input = event.target.value;
//         setIndustryInput(input);
//         if (input.trim() !== "") {
//             const filtered = industrySuggestions.filter((industry) =>
//                 industry.toLowerCase().includes(input.toLowerCase())
//             );
//             setFilteredSuggestions(filtered);
//             setShowDropdown(filtered.length > 0);
//         } else {
//             setShowDropdown(false);
//         }
//     };

//     const handleIndustryInputKeyDown = (event) => {
//         if (event.key === "Enter" && industryInput.trim() !== "") {
//             const inputValue = industryInput.trim();
//             const matchingSuggestion = industrySuggestions.find(
//                 (industry) => industry.toLowerCase() === inputValue.toLowerCase()
//             );

//             if (matchingSuggestion) {
//                 if (!industries.some(
//                     (industry) => industry.toLowerCase() === matchingSuggestion.toLowerCase()
//                 )) {
//                     setIndustries([...industries, matchingSuggestion]);
//                 } else {
//                     setIndustries(industries.map(ind =>
//                         ind.toLowerCase() === matchingSuggestion.toLowerCase() ? matchingSuggestion : ind
//                     ));
//                 }
//             } else {
//                 console.warn("Please select a valid industry from the suggestions.");
//             }

//             setIndustryInput("");
//             setShowDropdown(false);
//             event.preventDefault();
//         }
//     };

//     const handleSelectSuggestion = (industry) => {
//         if (!industries.some((ind) => ind.toLowerCase() === industry.toLowerCase())) {
//             setIndustries([...industries, industry]);
//         } else {
//             setIndustries(industries.map(ind =>
//                 ind.toLowerCase() === industry.toLowerCase() ? industry : ind
//             ));
//         }
//         setIndustryInput("");
//         setShowDropdown(false);
//     };

//     const removeIndustry = (indexToRemove) => {
//         setIndustries(industries.filter((_, index) => index !== indexToRemove));
//     };

//     return (
//         <div className={styles.accordionContent}>
//             <label>Industry</label>
//             <input
//                 type="text"
//                 placeholder="Enter industry or select..."
//                 value={industryInput}
//                 onChange={handleIndustryInputChange}
//                 onKeyDown={handleIndustryInputKeyDown}
//                 className={styles.filterInput}
//             />

//             {showDropdown && (
//                 <ul className={styles.dropdown}>
//                     {filteredSuggestions.map((industry, index) => (
//                         <li
//                             key={index}
//                             onClick={() => handleSelectSuggestion(industry)}
//                             className={styles.dropdownItem}
//                         >
//                             {capitalize(industry)}
//                         </li>
//                     ))}
//                 </ul>
//             )}

//             <div className={styles.selectedSection}>
//                 {industries.map((industry, index) => (
//                     <div key={index} className={styles.selectedChip}>
//                         {industry}
//                         <button onClick={() => removeIndustry(index)} className={styles.buttonX}>
//                             ×
//                         </button>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default IndustryFilter;


import React, { useState, useEffect } from "react";
import styles from './.FilterBoxComponents.module.css';
import { capitalize } from "functions/fields";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const IndustryFilter = ({ industries, setIndustries }) => {
    const [industryInput, setIndustryInput] = useState('');
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [industrySuggestions, setIndustrySuggestions] = useState([]); 

    useEffect(() => {
        const fetchSuggestions = async () => {
            try {
                // Ensure your backend endpoint /get_industry_suggestions selects id AND industry
                const res = await fetch(`${API_BASE_URL}/get_industry_suggestions`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });  
    
                const data = await res.json(); 
                // Store the full object, not just the string
                // Assuming data.results is [{id: 1, industry: 'Software'}, ...]
                setIndustrySuggestions(data.results || []); 
            } catch (err) {
                console.error("Failed to fetch industry suggestions:", err);
            }
        };
        fetchSuggestions();
    }, []);

    const handleIndustryInputChange = (event) => {
        const input = event.target.value;
        setIndustryInput(input);
        if (input.trim() !== "") {
            // Filter based on the string property of the object
            const filtered = industrySuggestions.filter((item) =>
                item.industry && item.industry.toLowerCase().includes(input.toLowerCase())
            );
            setFilteredSuggestions(filtered);
            setShowDropdown(filtered.length > 0);
        } else {
            setShowDropdown(false);
        }
    };

    const handleSelectSuggestion = (industryObj) => {
        // Check for duplicates based on ID
        if (!industries.some((ind) => ind.id === industryObj.id)) {
            setIndustries([...industries, industryObj]);
        }
        setIndustryInput("");
        setShowDropdown(false);
    };

    const removeIndustry = (indexToRemove) => {
        setIndustries(industries.filter((_, index) => index !== indexToRemove));
    };

    return (
        <div className={styles.accordionContent}>
            <label>Industry</label>
            <input
                type="text"
                placeholder="Enter industry or select..."
                value={industryInput}
                onChange={handleIndustryInputChange}
                className={styles.filterInput}
            />

            {showDropdown && (
                <ul className={styles.dropdown}>
                    {filteredSuggestions.map((item, index) => (
                        <li
                            key={item.id} // Use ID for key
                            onClick={() => handleSelectSuggestion(item)}
                            className={styles.dropdownItem}
                        >
                            {capitalize(item.industry)}
                        </li>
                    ))}
                </ul>
            )}

            <div className={styles.selectedSection}>
                {industries.map((item, index) => (
                    <div key={item.id || index} className={styles.selectedChip}>
                        {item.industry}
                        <button onClick={() => removeIndustry(index)} className={styles.buttonX}>
                            ×
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IndustryFilter;
